
(function() {
  var result = { translations: { "en": null } };
  result.translationsLoaded = {};
  result.translationsAvailable = {
  "email-management-ui": {
    "da": "static-1.12114",
    "de": "static-1.12114",
    "en": "static-1.12114",
    "es": "static-1.12114",
    "fi": "static-1.12114",
    "fr": "static-1.12114",
    "it": "static-1.12114",
    "ja": "static-1.12114",
    "ko": "static-1.12114",
    "nl": "static-1.12114",
    "no": "static-1.12114",
    "pl": "static-1.12114",
    "pt-br": "static-1.12114",
    "sv": "static-1.12114",
    "th": "static-1.12114",
    "zh-cn": "static-1.12114",
    "zh-tw": "static-1.12114"
  }
};
  hns('I18n', result);

})();


